import { GraphBuilder } from '../graph/builder';
import { ComponentDef } from './types';

export const mixtureOfDepthsComponent: ComponentDef = {
  id: 'mixture-of-depths',
  name: 'Mixture of Depths',
  description: 'Dynamically skip computation for low-importance tokens: only top-C% tokens are routed through the FFN; the rest take an identity bypass.',
  category: 'component',
  params: [
    { name: 'd_model', label: 'Model dimension', type: 'number', default: 512, min: 64, max: 4096, step: 64 },
    { name: 'seq_len', label: 'Sequence length', type: 'number', default: 128, min: 1, max: 8192, step: 1 },
    { name: 'd_ff', label: 'FFN dimension', type: 'number', default: 2048, min: 64, max: 16384, step: 64 },
    { name: 'capacity_factor', label: 'Capacity factor', type: 'number', default: 0.5, min: 0.1, max: 1, step: 0.1 }
  ],
  buildGraph: (params) => {
    const d_model = Number(params.d_model);
    const seq_len = Number(params.seq_len);
    const d_ff = Number(params.d_ff);
    const capacity_factor = Number(params.capacity_factor);
    const selected = Math.max(1, Math.round(seq_len * capacity_factor));
    const bypassed = seq_len - selected;

    const g = new GraphBuilder();
    g.input('x', [seq_len, d_model]);

    // ── Router: per-token scalar score → top-C% selection ──
    g.linear('depth_logits', 'x', [d_model, 1]);
    g.router('depth_mask', 'depth_logits', [seq_len, 1]);

    // ── Selected path: top-C% tokens go through FFN ──
    g.reshape('selected_tokens', 'depth_mask', [selected, d_model]);
    g.linear('ffn1', 'selected_tokens', [d_model, d_ff]);
    g.activation('act', 'ffn1', 'SiLU');
    g.linear('ffn2', 'act', [d_ff, d_model]);

    // ── Bypass path: remaining tokens skip FFN (identity) ──
    g.reshape('bypassed_tokens', 'x', [bypassed, d_model]);

    // ── Scatter: merge FFN outputs back to original token positions ──
    g.concat('merged', ['ffn2', 'bypassed_tokens'], [seq_len, d_model]);

    // ── Residual add ──
    g.add('out_add', 'x', 'merged');
    g.output('out', 'out_add');

    return g.build();
  }
};
